import React, { useState } from "react";

interface IInput {
  submitTodo: Function;
}

function Input(props: IInput) {
  const [input, setInput] = useState("");

  const clearInput = () => {};

  return (
    <div className="header p-5 rounded-md border border-sky-200 mb-2">
      <h1 className="font-bold text-xl">Lets get some things done!</h1>
      <p>Start by creating a todo</p>
      <form
        action=""
        onSubmit={(e) => {
          props.submitTodo(input, e);
          setInput("");
        }}
      >
        <div className="">
          <input
            className="textInput border w-full px-4 rounded-md h-10"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onSubmit={clearInput}
            type="text"
          />
          <input className="submitTodo" type="submit" value="Submit" />
        </div>
      </form>
    </div>
  );
}

export default Input;
